import * as React from "react";
const BreakpointDesktop = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 18", fill: "currentColor", width: size || "20", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4v2H7v1h7v-1h-3v-2h4a1 1 0 0 0 1-1H6V5h9v6h1V5a1 1 0 0 0-1-1H6Z" }));
BreakpointDesktop.displayName = "BreakpointDesktop";
var BreakpointDesktop_default = BreakpointDesktop;
export {
  BreakpointDesktop_default as default
};
